/**
 * Controls whether we show the new shipping preference page. See more information about this page here https:www.notion.so/faire/Global-Retailer-Carrier-Preferrences-342a1227ff6d40d7903138c7713a5c4d
 */ export var ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908 = 'ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908';
